import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../Component/const'
import { VehicleContext } from '../Component/Context/VehicleContext';
import DealVaultTable from '../Component/DealVault/DealVaultTable';
import ModalLayout from '../Component/Common/ModalLayout';
import AddNewAppraisalModal from '../Component/DealVault/AddNewAppraisalModal';

const DealVault = () => {
    const { numberFormatter, uploadLiveExport, getAllLiveData } = useContext(VehicleContext);

    const [searchText, setSearchText] = useState("");
    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    // Add New Appraisal
    const [openNewAppraisal, setOpenNewAppraisal] = useState(false);
    const handleAddNewAppraisal = () => {
        setOpenNewAppraisal(true);
        document.body.classList.add('overflow-body');
    }
    const handleCloseNewAppraisal = () => {
        setOpenNewAppraisal(false);
        document.body.classList.remove('overflow-body');
    }

    // Upload File 

    const [fileUploading,setFileUploading] = useState(false);
    const fileInputRef = useRef(null);
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        console.log("Uploaded File:", file);

        const formData = new FormData();
        formData.append('file', file);
        //formData.append('base_url',true);

        setFileUploading(true);

        const upload = uploadLiveExport(formData);
        upload.then((data) => {

            console.log("uploaded");

            setFileUploading(false);
        });
    };

    const [saleData,setSaleData] = useState([]);

    useEffect(() => {
        getSaleData();
    }, [])

    const getSaleData = async () => {

        const data = await getAllLiveData();

        setSaleData(data);

    };

    return (
        <>
            <div className='main-card'>
                <div className='d-flex align-items-center justify-content-between dv-header-flex mb-4'>
                    <div className='md-title text-uppercase fw-700 font-1-8em'>Deal Vault</div>
                    <div className='d-inline-flex'>
                        <button type='button' className='red-btn text-uppercase ms-4' onClick={handleAddNewAppraisal}>Add New Appraisal</button>
                        {!fileUploading && <div className='d-inline-block position-relative'>
                            <button
                                className="red-transparent-btn text-uppercase d-inline-block text-nowrap upload-exl-btn ms-4"
                                type="button"
                                onClick={handleButtonClick}
                            >
                                <img src={getImages('file-excel-icon.png')} /> Upload File
                            </button>

                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileUpload}
                            />
                        </div>}
                        <div className='da-search-fields ms-4'>
                            <div className='position-relative'>
                                <input type='text'
                                    className='form-control'
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='common-box-border'>
                    {saleData && <DealVaultTable
                        data={saleData}
                        numberFormatter={numberFormatter}
                        searchText={searchText}
                    />}
                </div>
            </div>
            {openNewAppraisal &&
                <ModalLayout open={openNewAppraisal} close={handleCloseNewAppraisal} modalWidth={1138} darkThemeCls="true">
                    <AddNewAppraisalModal close={handleCloseNewAppraisal} />
                </ModalLayout>
            }
        </>
    )
}

export default DealVault